import React from 'react'
import {
  ComboBoxComponent,
  FilteringEventArgs,
} from '@syncfusion/ej2-react-dropdowns'
import { CHART_NAME_OPTIONS } from '@constants/Charting/chartNameOptions'

type ChartNameComboBoxProps = {
  value: string
  onChange: (title: string) => void
  readOnly: boolean
  disabled?: boolean
  isInvalid?: boolean
}

const getChartNameSuggestions = (query: string): string[] => {
  const trimmedQuery = query.trim()
  const normalizedQuery = trimmedQuery.toLowerCase()
  if (!normalizedQuery) {
    return [...CHART_NAME_OPTIONS]
  }
  const matches = CHART_NAME_OPTIONS.filter((option) =>
    option.toLowerCase().includes(normalizedQuery),
  )
  return matches.length > 0 ? matches : [trimmedQuery]
}

/**
 * Keep ComboBox mounted; swapping to Form.Control on readOnly causes Syncfusion removeChild crashes.
 */
const ChartNameComboBox = ({
  value,
  onChange,
  readOnly,
  disabled = false,
  isInvalid = false,
}: ChartNameComboBoxProps): React.ReactElement => {
  const handleFiltering = (e: FilteringEventArgs): void => {
    if (readOnly) {
      return
    }
    e.preventDefaultAction = true
    e.updateData(getChartNameSuggestions(e.text ?? ''))
  }

  return (
    <ComboBoxComponent
      dataSource={[...CHART_NAME_OPTIONS]}
      allowCustom={!readOnly}
      allowFiltering={!readOnly}
      filterType="Contains"
      placeholder="Chart name"
      value={value}
      readonly={readOnly}
      enabled={!disabled && !readOnly}
      noRecordsTemplate=""
      filtering={handleFiltering}
      change={(e): void => {
        if (readOnly || e.isInteracted === false) {
          return
        }
        const nextTitle =
          e.value === undefined || e.value === null ? '' : String(e.value)
        if (nextTitle === value) {
          return
        }
        onChange(nextTitle)
      }}
      cssClass={`charting-combobox${isInvalid ? ' border-danger' : ''}${
        disabled || readOnly ? ' disabled pe-none' : ''
      }`}
    />
  )
}

export default ChartNameComboBox
